module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("2Am5B"))).then(() => parcelRequire('d0iPb'));